export const defaultTheme = {
  palette: {
    primary: {
      light: '#8145CB',
      main: '#641ABF',
      dark: '#000D5B'
    },
    secondary: {
      main: '#444444'
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5FA'
    },
    warning: {
      main: '#EF3826',
      dark: '#EA0234'
    },
    info: {
      main: '#4883F7'
    },
    success: {
      main: '#11BFA4'
    }
  },
  typography: {
    fontFamily: 'Nunito',
    fontSize: 14,
    subtitle1: {
      fontSize: '13px',
      fontWeight: 600,
      fontFamily: 'Roboto',
      color: '#8145CB'
    },
    menu: {
      fontSize: '14px',
      fontFamily: 'Nunito',
      fontWeight: 600,
      color: '#8145CB'
    },
    h2: {
      fontSize: '48px',
      fontWeight: 600,
      color: '#000D5B'
    },
    body1: {
      fontSize: '14px',
      fontFamily: 'Roboto',
      fontWeight: 600,
      color: '#444444'
    },
    body2: {
      fontSize: '22px',
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#000D5B'
    },
    subtitle2: {
      fontSize: '16px',
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#666666'
    }
  }
};
